import { MESSAGE_TYPES } from "../../../packages/constants";
import type {
  ApiMessage,
  ApiMessageText,
  ApiMessageFile,
  ApiMessageButtons,
  ApiMessageService,
  ApiMessageContentButtonCallback,
  ApiMessageContentButtonLink,
} from "../types";

export const isApiMessageText = (
  message: ApiMessage
): message is ApiMessageText => message.type === MESSAGE_TYPES.TEXT;

export const isApiMessageFile = (
  message: ApiMessage
): message is ApiMessageFile => message.type === MESSAGE_TYPES.FILE;

export const isApiMessageService = (
  message: ApiMessage
): message is ApiMessageService => message.type === MESSAGE_TYPES.SERVICE;

export const isApiMessageButtons = (
  message: ApiMessage
): message is ApiMessageButtons =>
  message.type === MESSAGE_TYPES.BUTTONS || message.type === "button";

export const isApiMessageButtonLink = (
  button: ApiMessageContentButtonCallback | ApiMessageContentButtonLink
): button is ApiMessageContentButtonLink => "url" in button;

export const isApiMessageButtonCallback = (
  button: ApiMessageContentButtonCallback | ApiMessageContentButtonLink
): button is ApiMessageContentButtonCallback => "callback" in button;
